import { PostChartHttpBuilder } from '../../social-listening/services/posts-chart.http';

export class UsersPostChartHttpBuilder extends PostChartHttpBuilder {
    protected override getMediaTypeFilter() {
        return {};
    }
}
